module.exports = __webpack_public_path__ + "media/crypto/comp-26d3a005.png";